// extracted by mini-css-extract-plugin
export default {"auth":"style_auth__S5vyF","formRegister":"style_formRegister__qSLmA"};